require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-jsiebern-bs-material-ui.json") })
        }
      }, "path---package-jsiebern-bs-material-ui");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-jsiebern-bs-material-ui!./.cache/json/package-jsiebern-bs-material-ui.json
// module id = 873
// module chunks = 231608221292675